<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="solve head-label" style="margin-top: 80px">
            <div style="text-align: center;" class="font_size_30">
                一站式解决方案
            </div>
        </div>
        <!-- 盒子 -->
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[1].img" class="img_border" />
                        </div>
                        <div class="border_title">{{ images[1].title }}</div>
                        <div class="border_content_one">{{ images[1].content[0] }}</div>
                        <div class="border_content_two">{{ images[1].content[1] }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[2].img" class="img_border" />
                        </div>
                        <div class="border_title">{{ images[2].title }}</div>
                        <div class="border_content_one">{{ images[2].content[0] }}</div>
                        <div class="border_content_two">{{ images[2].content[1] }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[3].img" class="img_border" />
                        </div>
                        <div class="border_title">{{ images[3].title }}</div>
                        <div class="border_content_one">{{ images[3].content[0] }}</div>
                        <div class="border_content_two">{{ images[3].content[1] }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[4].img" class="img_border" />
                        </div>
                        <div class="border_title">{{ images[4].title }}</div>
                        <div class="border_content_one">{{ images[4].content[0] }}</div>
                        <div class="border_content_two">{{ images[4].content[1] }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 手机端商品展示 -->
        <div id="产品微观" class="head-label" style="margin-top: 80px">
            <div style="text-align: center;" class="font_size_30">
                产品介绍
            </div>
        </div>
        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content">
                        <div class="product_mobile_title font_size_30" style="margin-top: 40px;">{{ products[0].title }}
                        </div>
                        <div class="product_font_style product_mobile_content_one"
                            v-for="(item, index) in products[0].content" :key="index" style="margin-top: 30px;">{{ item }}
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <img :src="products[0].img[0]" class="product_mobile_img" />
                    <img :src="products[0].img[1]" class="product_mobile_img" />
                </el-col>
            </el-row>
        </div>
        <!-- 后台管理 -->
        <div class="product_pc">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_pc_one">
                        <div class="product_mobile_title font_size_30" style="margin-top: 40px;">{{ manages[0].title }}
                        </div>
                        <div style="margin-top: 30px" class="product_font_style" v-for="(item, index) in manages[0].content"
                            :key="index">{{ item }}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <img :src="manages[0].img[0]" class="product_pc_img" />
                </el-col>
            </el-row>
        </div>
        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label" style="margin-top: 80px">
            <div style="text-align: center;" class="font_size_30">
                关于我们
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <p class="about_me_p" style="line-height: 50px;">
                    上海弘轩合创信息系统集成有限公司成立于2021-06-17，企业地址位于上海市奉贤区金钱公路3329号4幢，所属行业为软件和信息技术服务业，经营范围包含：许可项目：各类工程建设活动；施工专业作业（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）一般项目：信息系统集成服务；计算机系统服务；计算机及办公设备维修；信息技术咨询服务；信息系统运行维护服务；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；计算机软硬件及辅助设备批发；计算机软硬件及辅助设备零售；计算机软硬件及外围设备制造（限分支机构经营）；电子产品销售；通用设备修理；专用设备修理；电气设备修理；仪器仪表修理；普通机械设备安装服务；家用电器安装服务；机械设备租赁；计算机及通讯设备租赁；软件开发；物联网技术服务；机械设备销售；通讯设备销售；电气设备销售；办公设备销售；通信设备销售；专业设计服务；信息咨询服务（不含许可类信息咨询服务）；工程管理服务；数据处理服务（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）。
                </p>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            sliders: [],
            images: [
                {
                    img: require('../../static/other/用户管理.png'),
                    title: "用户管理",
                    content: ["用户消费分析", "用户标签设定"]
                },
                {
                    img: require('../../static/other/智慧物联.png'),
                    title: "智慧物联",
                    content: ["即时数据采集", "智能数据预测"]
                },
                {
                    img: require('../../static/other/协同工作.png'),
                    title: "协同工作",
                    content: ["在线一键报修", "工单任务追踪"]
                }, {
                    img: require('../../static/other/实时预警.png'),
                    title: "实时预警",
                    content: ["预警模型训练", "项目实时预警"]
                },
                {
                    img: require('../../static/other/数据分析.png'),
                    title: "数据分析",
                    content: ["各种报表统计", "未来趋势预测"]
                }
            ],
            products: [
                {
                    img: [require('../../static/other/2.jpg'), require('../../static/other/3.jpg')],
                    title: "APP功能展示",
                    content: [
                        "报修：微信扫码报修或平台内报修",
                        "工单：在线派单、工单意见反馈",
                        "预警：查看预警信息、预警派遣处理",
                        "实时监控：查看项目监控画面",
                    ]
                }
            ],
            manages: [
                {
                    img: [require('../../static/other/1.png')],
                    title: "PC功能据展示",
                    content: ["工单系统：报修、派单、工单审批",
                        "供水系统：物联网实时数据采集、实时预警",
                        "电梯系统：电梯运行状况监控、不文明行为监测",
                        "高压配电系统：配电柜数据实时采集、实时预警",
                    ]
                }
            ],
            spec: {
                img: require('../../static/other/arrow.png'),
                product: [
                    {
                        img: require('../../static/other/手指.png'),
                        title: "一键建铺",
                        contents: ["注册一键创建店铺", "开启您的专属店铺"]
                    },
                    {
                        img: require('../../static/other/店铺管理.png'),
                        title: "店铺装扮",
                        contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"]
                    },
                    {
                        img: require('../../static/other/数据分析.png'),
                        title: "营销分析",
                        contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"]
                    },
                    {
                        img: require('../../static/other/助力零售.png'),
                        title: "助力零售",
                        contents: ["提供专业产品服务", "帮助线下零售业态提升营销"]
                    }
                ]
            },
            company: [
                "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
            ],
            carousel_height: '550px',
        }
    },
    methods: {},
    mounted() {
        this.sliders = [
            {
                img: require("../../static/slider/a1.jpg")
            },
            {
                img: require("../../static/slider/a2.jpg")
            },
            {
                img: require('../../static/slider/a3.jpg')
            },
            {
                img: require('../../static/slider/a4.jpg')
            }
        ]
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        },
        computeArrowImg() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 450) {
                return require('../../static/other/arrow.png');
            } else {
                return require('../../static/other/arrow_down.png');
            }
        }

    },
}
</script>

<style scoped>
.border_parent {
    width: 90%;
    margin: auto;
}

.slider_img {
    height: 550px;
    width: 100%;
}

.solve {
    margin-top: 30px;
    margin-bottom: 10px
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 30%;
    margin-left: 10%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 2em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #F2F6FC;
    align-items: center;
}

.product_spec_title {
    margin-top: 30px;
    margin-bottom: 10px
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: "PingFang SC";
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #F2F6FC;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    text-align: center;
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #F2F6FC;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #F2F6FC;
        flex-direction: column;
    }

    .head-label {
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        width: 100%;
    }
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center
}

.font_size_24 {
    font-size: 1.5em;
}

.font_size_30 {
    font-size: 2em;
    font-weight: 600;
}
</style>